import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import NoImageAvailable from "../../../assets/images/no-image-available.jpg";
import { OfferServiceService } from "../../../services/offerServiceService";

function statusBadge(promo) {
  const now = Date.now();
  const start = promo.applyStartDate
    ? new Date(promo.applyStartDate).getTime()
    : null;
  const end = promo.applyEndDate
    ? new Date(promo.applyEndDate).getTime()
    : null;

  if (end && now > end)
    return { text: "Đã kết thúc", cls: "bg-gray-200 text-gray-700" };
  if (start && now < start)
    return { text: "Sắp diễn ra", cls: "bg-blue-100 text-blue-700" };
  return { text: "Đang diễn ra", cls: "bg-green-100 text-green-700" };
}

const ServicesOffers = () => {
  const navigate = useNavigate();
  const [servicesOffers, setServicesOffers] = useState([]);

  const fetchServicesOffers = async () => {
    try {
      const response = await OfferServiceService.getOfferServices({
        page: 1,
        pageSize: 3,
      });
      if (!response.Data) {
        // toast.error("Lỗi lấy danh sách dịch vụ/ưu đãi!");
        return;
      }
      const { listData } = response.Data;
      setServicesOffers(listData);
    } catch (error) {
      // toast.error("Lỗi lấy danh sách dịch vụ/ưu đãi!");
    }
  };

  useEffect(() => {
    fetchServicesOffers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="bg-white p-6 w-full lg:px-40">
      {/* Title */}
      <div className="mb-6">
        <span className="font-bold">Dịch vụ & Ưu đãi</span>
      </div>

      {/* Product Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-6">
        {servicesOffers.map((item) => {
          const badge = statusBadge(item);
          return (
            <div
              key={item.slug}
              className="flex flex-col bg-white rounded-xl overflow-hidden shadow-sm border border-gray-100"
            >
              <div className="relative">
                <img
                  src={item.images || NoImageAvailable}
                  alt={item.title}
                  className="w-full aspect-[16/10] object-cover"
                  loading="lazy"
                />
                <span
                  className={`absolute top-2 left-2 px-2 py-1 text-xs rounded-md ${badge.cls}`}
                >
                  {badge.text}
                </span>
              </div>

              <div className="p-4 lg:p-5 flex-1 flex flex-col justify-between">
                <div className="flex-1 flex flex-col">
                  <h2 className="text-lg lg:text-xl font-semibold line-clamp-2">
                    {item.title}
                  </h2>
                  <p className="text-sm text-gray-600 mt-2 line-clamp-3">
                    {item.excerpt}
                  </p>

                  {/* thời gian ngắn gọn */}
                  {(item.applyStartDate || item.applyEndDate) && (
                    <p className="text-xs text-gray-500 mt-3">
                      {item.applyStartDate && (
                        <>
                          Từ:{" "}
                          {new Date(item.applyStartDate).toLocaleDateString(
                            "vi-VN"
                          )}
                        </>
                      )}
                      {item.applyEndDate && (
                        <>
                          {" "}
                          • Đến:{" "}
                          {new Date(item.applyEndDate).toLocaleDateString(
                            "vi-VN"
                          )}
                        </>
                      )}
                    </p>
                  )}
                </div>

                <div className="mt-4 lg:mt-5">
                  <button
                    onClick={() => navigate(`/services-offers/${item.slug}`)}
                    className="w-full lg:w-auto px-4 py-2 rounded-md border border-gray-300 hover:bg-gray-100 transition"
                  >
                    Xem chi tiết
                  </button>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* View All */}
      <div className="mt-6 text-center">
        <a
          href={`/services-offers/`}
          className="text-primaryColor underline hover:text-blue-500"
        >
          Xem tất cả dịch vụ & ưu đãi
        </a>
      </div>
    </div>
  );
};

export default ServicesOffers;
